<script setup lang="ts">
import ILxcInfo from "~icons/lxc/info";

defineProps<{
  organizationCode?: number;
  businessUnitCode?: number;
}>();

const { t } = useI18n();
</script>

<template>
  <div class="flex border border-gray-300 rounded-lg mt-6 p-4 relative">
    <div
      class="border border-gray-300 rounded-lg p-2 mr-4 text-gray-500 justify-center items-center"
    >
      <i-lxc-info height="1.5em" width="1.5em" />
    </div>
    <div>
      <div class="font-semibold">
        {{ t("license.idCard.title") }}
      </div>
      <div>{{ t("license.idCard.description") }}</div>
    </div>
    <div class="absolute right-4">
      <export-id-card-button
        :organization-code="organizationCode"
        :business-unit-code="businessUnitCode"
      />
    </div>
  </div>
</template>
